import './FeaturedNews.scss';
import template from './FeaturedNews.vhtml';

export default {
	name: 'FeaturedNews',
	template: template,
	props: {
		items: {
			type: Array,
			default: null,
		},
	},
	data: () => ({}),
	computed: {
		shaveHeight() {
			if (window.innerWidth < 1024) {
				return 40;
			}
			return 80;
		},
	},
	methods: {
		formatDate(date) {
			return this.$moment(String(date)).format('D. MMMM YYYY');
		},
	},
};
